module.exports = __webpack_public_path__ + "img/tema-3-14.2f27adcf.svg";